export const normalizeWorkspaceRoute = ({
  sections = [],
  defaultSectionId,
  defaultViewId,
  sectionId,
  viewId,
} = {}) => {
  const visibleSections = sections.filter((section) => section?.visible !== false);
  const fallbackSection =
    visibleSections.find((section) => section.id === defaultSectionId)
    || visibleSections[0]
    || null;
  const activeSection =
    visibleSections.find((section) => section.id === sectionId)
    || fallbackSection;

  if (!activeSection) {
    return {
      sectionId: defaultSectionId,
      viewId: defaultViewId,
      section: null,
      view: null,
    };
  }

  const visibleViews = (activeSection.views || []).filter((view) => view?.visible !== false);
  const fallbackView =
    visibleViews.find((view) => view.id === defaultViewId)
    || visibleViews[0]
    || null;
  const activeView =
    visibleViews.find((view) => view.id === viewId)
    || fallbackView;

  return {
    sectionId: activeSection.id,
    viewId: activeView?.id || defaultViewId,
    section: activeSection,
    view: activeView,
  };
};

export const buildWorkspaceSidebarItems = ({
  sections = [],
  buildPath,
  routeState = {},
} = {}) => (
  sections
    .filter((section) => section?.visible !== false)
    .map((section) => {
      const visibleViews = (section.views || []).filter((view) => (
        view?.visible !== false && view?.navigationVisible !== false
      ));
      const defaultView = visibleViews[0];
      const sectionPath = buildPath
        ? buildPath({ sectionId: section.id, viewId: defaultView?.id, ...routeState })
        : section.to;

      return {
        ...section,
        to: sectionPath,
        views: visibleViews.map((view) => ({
          ...view,
          to: buildPath
            ? buildPath({ sectionId: section.id, viewId: view.id, ...routeState })
            : view.to,
        })),
      };
    })
);

export const buildWorkspaceChips = ({
  section,
  view,
} = {}) => {
  const ViewIcon = view?.icon;
  const isPreview = String(view?.badge || section?.badge || '').toLowerCase() === 'preview';
  const accessPolicyId = isPreview
    ? null
    : view?.accessPolicyId || section?.accessPolicyId;

  return [
    view ? { label: view.label, icon: ViewIcon } : null,
    accessPolicyId ? { label: 'Research', accessPolicyId, tier: true } : null,
  ].filter(Boolean);
};

const flattenNavigationItems = (items = []) => (
  items.flatMap((item) => (
    Array.isArray(item?.items) ? item.items : item
  )).filter(Boolean)
);

export const buildWorkspaceDepthLinks = ({
  sidebarGroups,
  sidebarItems,
  activeNavigationItemId,
  activeNavigationLevelId,
} = {}) => {
  if (!activeNavigationItemId || !activeNavigationLevelId) return [];

  const navigationItems = flattenNavigationItems(
    sidebarGroups?.length ? sidebarGroups : sidebarItems
  );
  const activeItem = navigationItems.find((item) => item.id === activeNavigationItemId);
  const levels = (activeItem?.levels || []).filter((level) => (
    level?.id
    && level?.label
    && level.id !== 'view'
  ));

  if (levels.length <= 1) return [];

  return levels.map((level) => ({
    id: level.id,
    label: level.label,
    to: level.to,
    icon: level.icon,
    active: level.id === activeNavigationLevelId,
  }));
};
